import React, { useEffect, useCallback } from 'react';
import {
  // message,
  Spin,
} from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import routes from '@routes/routes';
import authProvider from '@utils/auth/createAuthProvider';
import userApi from '@api/userApi';
import userActions from '@state/user/actions';
import CenteredContent from '@common/components/ui/CenteredContent';
// import useSocket from '@common/hooks/useSocket';

const { useAuth } = authProvider;

function withAuth(Component) {

  // eslint-disable-next-line
  return (props) => {

    const { t } = useTranslation();
    const dispath = useDispatch();
    const history = useHistory();
    const [logged] = useAuth();
    // const { connectSocket } = useSocket();

    const isLogged = useSelector(({ user }) => user.isLogged);

    const getUserData = useCallback(
      () => {

        if (isLogged) return;

        userApi
          .me()
          .then((user) => {

            dispath(userActions.userUpdate(user));

          })
          .catch((resError) => {

            const { fem } = resError;
            // eslint-disable-next-line
            console.log(t(fem));

          });

      },

      [isLogged, dispath, t],
    );

    useEffect(
      // eslint-disable-next-line consistent-return
      () => {

        const { path } = routes.find(() => 'LOGIN');
        if (!logged) return history.push(path || '/null');

        getUserData();

      },

      [logged, getUserData, history],
    );

    useEffect(() => [isLogged]);

    if (!isLogged) {

      return (
      // eslint-disable-next-line react/jsx-filename-extension
        <CenteredContent>
          <>
            <Spin tip={t('common.feedbacks.loading_data_user')} />
          </>
        </CenteredContent>
      );

    }
    // if (!isLogged) return <Title level={4}>{t('common.feedbacks.loading_data_user')}</Title>;
    return <Component {...props} />;

  };

}

export default withAuth;
